"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var tslib_1 = require("tslib");

var jsx_runtime_1 = require("@emotion/react/jsx-runtime");
/** @jsxImportSource @emotion/react */


var react_1 = require("react");

var react_dom_1 = require("react-dom");

var Button_1 = tslib_1.__importDefault(require("../../Buttons/Button"));

var hooks_1 = require("../../../hooks");

var styles = tslib_1.__importStar(require("./TopSheet.style"));

function TopSheet(_ref) {
  var _ref$modalKey = _ref.modalKey,
      modalKey = _ref$modalKey === void 0 ? '' : _ref$modalKey,
      isOpen = _ref.isOpen,
      _ref$isAboveDialog = _ref.isAboveDialog,
      isAboveDialog = _ref$isAboveDialog === void 0 ? false : _ref$isAboveDialog,
      _ref$showBackdrop = _ref.showBackdrop,
      showBackdrop = _ref$showBackdrop === void 0 ? true : _ref$showBackdrop,
      _ref$preventParentScr = _ref.preventParentScroll,
      preventParentScroll = _ref$preventParentScr === void 0 ? true : _ref$preventParentScr,
      toggle = _ref.toggle,
      confirmButtonContent = _ref.confirmButtonContent,
      optionButtonContent = _ref.optionButtonContent,
      closeButtonContent = _ref.closeButtonContent,
      _ref$disabledConfirmB = _ref.disabledConfirmButton,
      disabledConfirmButton = _ref$disabledConfirmB === void 0 ? false : _ref$disabledConfirmB,
      _ref$disabledOptionBu = _ref.disabledOptionButton,
      disabledOptionButton = _ref$disabledOptionBu === void 0 ? false : _ref$disabledOptionBu,
      _ref$onConfirmClick = _ref.onConfirmClick,
      onConfirmClick = _ref$onConfirmClick === void 0 ? function () {
    return null;
  } : _ref$onConfirmClick,
      _ref$onOptionClick = _ref.onOptionClick,
      onOptionClick = _ref$onOptionClick === void 0 ? function () {
    return null;
  } : _ref$onOptionClick,
      _ref$onCloseClick = _ref.onCloseClick,
      onCloseClick = _ref$onCloseClick === void 0 ? function () {
    return null;
  } : _ref$onCloseClick,
      _ref$className = _ref.className,
      className = _ref$className === void 0 ? '' : _ref$className,
      children = _ref.children;
  var hasButtonContent = react_1.useMemo(function () {
    return optionButtonContent || confirmButtonContent || closeButtonContent;
  }, [optionButtonContent, confirmButtonContent, closeButtonContent]);
  var handleClose = react_1.useCallback(function () {
    toggle(false);
  }, [toggle]);
  var handleConfirmClick = react_1.useCallback(function () {
    onConfirmClick && onConfirmClick();
  }, [onConfirmClick]);
  var handleOptionClick = react_1.useCallback(function () {
    onOptionClick && onOptionClick();
  }, [onOptionClick]);
  var handleClosableClick = react_1.useCallback(function () {
    onCloseClick && onCloseClick();
    handleClose();
  }, [onCloseClick]);
  hooks_1.useModalHistory(modalKey, isOpen, handleClose);
  react_1.useEffect(function () {
    if (!preventParentScroll) {
      return;
    }

    if (isOpen) {
      document.body.setAttribute('style', 'overflow: hidden');
      return;
    }

    document.body.setAttribute('style', '');
  }, [isOpen, preventParentScroll]);
  return jsx_runtime_1.jsxs(react_1.Fragment, {
    children: [react_dom_1.createPortal(jsx_runtime_1.jsxs("div", Object.assign({
      role: "dialog",
      className: className,
      css: [styles.container, isOpen ? styles.topSheetShow : styles.topSheetHide, isAboveDialog && styles.isAboveDialog]
    }, {
      children: [jsx_runtime_1.jsx("div", Object.assign({
        className: "mrt-top-sheet-content",
        css: styles.content
      }, {
        children: children
      }), void 0), hasButtonContent && jsx_runtime_1.jsxs("div", Object.assign({
        css: styles.buttonContainer
      }, {
        children: [confirmButtonContent && jsx_runtime_1.jsxs("div", Object.assign({
          css: styles.actionContainer
        }, {
          children: [optionButtonContent && jsx_runtime_1.jsx("div", Object.assign({
            css: styles.optionButton
          }, {
            children: jsx_runtime_1.jsx(Button_1.default, Object.assign({
              disabled: disabledOptionButton,
              type: "gray",
              size: "large",
              onClick: handleOptionClick
            }, {
              children: optionButtonContent
            }), void 0)
          }), void 0), jsx_runtime_1.jsx("div", Object.assign({
            css: styles.confirmButton
          }, {
            children: jsx_runtime_1.jsx(Button_1.default, Object.assign({
              disabled: disabledConfirmButton,
              type: "primary",
              size: "large",
              onClick: handleConfirmClick
            }, {
              children: confirmButtonContent
            }), void 0)
          }), void 0)]
        }), void 0), closeButtonContent && jsx_runtime_1.jsx("button", Object.assign({
          type: "button",
          css: styles.closeBtn,
          onClick: handleClosableClick
        }, {
          children: closeButtonContent
        }), void 0)]
      }), void 0)]
    }), void 0), document.body), showBackdrop && jsx_runtime_1.jsx("div", {
      className: className,
      css: [styles.backdrop, isOpen ? styles.backdropShow : styles.backdropHide],
      onClick: handleClosableClick
    }, void 0)]
  }, void 0);
}

exports.default = TopSheet;